/* @ngInject */
function LoginSsoController (
  $scope,
  $rootScope,
  $timeout,
  $state,
  $stateParams,
  $location,
  $translate,
  $window,
  InitializerService,
  AuthService,
  SegmentService,
  CONSTANTS,
  Utils,
  ToastService,
  BackendErrorParserService,
  LocalStorageService,
  RequestDeduplicationService
) {
  const nextUrlKey = 'nextUrl'
  const sHost = $location.host()
  $scope.subdomain = ''
  $scope.customerLogoPath = ''
  $scope.backgroundUrl = ''
  $scope.backgroundImageUrl = ''
  $scope.userLogin = {
    email: $stateParams.email
  }
  $scope.flags = {
    loadingLogo: true,
    loadingBackground: true
  }

  const api = {
    activate,
    loginSuccess,
    onSsoValidationSuccess,
    checkShouldAutoLogin
  }

  this.getApi = () => api

  activate()

  function activate () {
    RequestDeduplicationService.clearCache()
    AuthService.setContainerPosition()
    const isInReactNativeWebView = Utils.isInReactNativeWebView()

    AuthService.getCustomerImages(sHost).then(url => {
      $scope.customerLogoPath = url.logo
      $scope.backgroundUrl = url.background
      $scope.subdomain = localStorage.getItem('companySubdomain')
    }).finally(() => {
      api.checkShouldAutoLogin()
    })

    if ($stateParams.error) {
      if ($stateParams.error === 'SSO_INTEGRATION_NOT_FOUND') {
        $scope.wrongMessage = $translate.instant('ssoValidationError')
      } else {
        $scope.ssoHasFailedAuthError = true
        $scope.wrongMessage = $translate.instant('ssoFailedAuthError')
      }

      $scope.isSsoError = true
    }

    if ($stateParams.email) {
      $location.search('email', null)
    }

    if ($stateParams.jwt) {
      if (isInReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ jwt: $stateParams.jwt, type: 'JWT_TOKEN' }))
        return
      }

      $scope.loginBtnLoading = true
      AuthService.setJwtToken($stateParams.jwt)

      loginSuccess()
    }
  }

  function onSsoValidationSuccess ({ userHasSSOAccess, companyHasSSOEnabled, ssoAutoSignin }) {
    $scope.ssoHasFailedAuthError = false

    if (!companyHasSSOEnabled) {
      $scope.isSsoError = true
      $scope.wrongMessage = $translate.instant('ssoValidationError')
      return
    }

    if (!userHasSSOAccess && !ssoAutoSignin) {
      ToastService.showErrorToast($translate.instant('SSOAccess.cantLoginWithSso'))
      $state.go('login', {
        skipSsoValidation: true,
        email: $scope.userLogin.email
      })
      return
    }

    $scope.isSsoError = false
    $scope.wrongMessage = null

    const nextUrl = $stateParams.next
    if (nextUrl) {
      LocalStorageService.set(nextUrlKey, nextUrl)
    }

    const url = Utils.fnAddQueryToUrl(CONSTANTS.URL_AUTH_SSO_LOGIN, {
      email: $scope.userLogin.email,
      subdomain: $scope.subdomain
    })

    $window.open(url, '_self')
  }

  function loginSuccess () {
    $scope.userLogin = {}
    return InitializerService.initApplication().then(() => {
      SegmentService.track('user-login', { id: $rootScope.oUser.id, sso_enabled: true })

      if ($rootScope.oUser.onboarding_status === 'COMPANY') {
        $state.go('onboardingStepCompany')
      } else if ($rootScope.oUser.onboarding_status === 'MODULES') {
        $state.go('onboardingStepModules')
      } else if ($rootScope.oUser.onboarding_status === 'BRANDING') {
        $state.go('onboardingStepBranding')
      } else {
        const nextUrl = LocalStorageService.get(nextUrlKey)

        if (nextUrl) {
          LocalStorageService.del(nextUrlKey)
          $location.url(nextUrl)
        } else {
          $state.go('home')
        }
      }
    })
  }

  function checkShouldAutoLogin () {
    if (!$stateParams.userEmail || $stateParams.jwt) {
      return
    }

    $scope.userLogin.email = $stateParams.userEmail
    $scope.login()
  }

  $scope.login = function () {
    $scope.isSsoError = false
    $scope.wrongMessage = null
    if (!$scope.userLogin.email) {
      $scope.isSsoError = true
      $scope.wrongMessage = $translate.instant('ssoValidationError')
      return
    }

    $scope.loginBtnLoading = true

    AuthService.validateSsoEnabled($scope.userLogin.email, $scope.subdomain)
      .then(onSsoValidationSuccess)
      .catch((error) => {
        if (BackendErrorParserService.isRateLimitError(error)) {
          const retryAfterHeader = error.headers('retry-after')

          if (retryAfterHeader) {
            const retryAfterMinutes = Utils.convertSecondsToMinutes(retryAfterHeader)
            const toastText = $translate.instant('tooManyRequests', { retryAfterMinutes })

            ToastService.showErrorToast(toastText)
          }
        }
      })
      .finally(() => {
        $scope.loginBtnLoading = false
      })
  }

  $scope.onLogoLoad = function () {
    $timeout(() => {
      $scope.flags.loadingLogo = false
    })
  }

  $scope.onBackgroundLoad = function () {
    $timeout(() => {
      $scope.backgroundImageUrl = $scope.backgroundUrl
      $scope.flags.loadingBackground = false
    })
  }

  $scope.goToDefaultLogin = function () {
    $state.go('login', {
      skipSsoValidation: true
    })
  }

  $scope.onEmailChange = function (evt) {
    $scope.userLogin.email = evt.detail.value
  }
}

export { LoginSsoController }
